import { render, staticRenderFns } from "./SmsBroadcastRecipientCount.vue?vue&type=template&id=d5a7355c&scoped=true"
import script from "./SmsBroadcastRecipientCount.vue?vue&type=script&lang=js"
export * from "./SmsBroadcastRecipientCount.vue?vue&type=script&lang=js"
import style0 from "./SmsBroadcastRecipientCount.vue?vue&type=style&index=0&id=d5a7355c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a7355c",
  null
  
)

export default component.exports